<ecmo-page [pageTitle]="'documents-request.situation-letter.title' | translate" [greyBackground]='true'>
  <div class='container'>
    <div class='column'>
      <div class='row column no-gap'>
        <p class='label' [innerHTML]="'documents-request.situation-letter.demand' | translate"></p>
        <p class='label' [innerHTML]="'documents-request.situation-letter.method' | translate"></p>
      </div>
      <div class='row'>
        <button mat-flat-button color='primary' [routerLink]="['../situation-letter-landing']"
                (click)='sendSituationLetterDemand()'>{{ 'documents-request.situation-letter.confirm' |
          translate }}</button>
      </div>
      <div class='row'>
        <button mat-stroked-button class='no-border'
                [routerLink]="['..']">{{ 'global.cancel' | translate }}</button>
      </div>
    </div>
  </div>

  <ecmo-footer></ecmo-footer>
</ecmo-page>
